// import { Box, Button, Flex } from "@chakra-ui/react";
import { NavLink,Link } from "react-router-dom";
import AnchorLink from "react-anchor-link-smooth-scroll";
import styled, { keyframes } from "styled-components";
import resume from "../Images/Ansh-Kathpal-Resume.pdf";
import hamburger from "../Images/menu.png";

import { ReactNode, useState } from "react";
import {
  Box,
  Flex,
  Avatar,
  // Link,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  useDisclosure,
  useColorModeValue,
  Stack,
  useColorMode,
  Center,
  Text,
} from "@chakra-ui/react";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";

export function Navbar() {
  const [isVisible1, setIsVisible1] = useState(true);
  const [isVisible2, setIsVisible2] = useState(true);
  const [isVisible3, setIsVisible3] = useState(true);
  const [isVisible4, setIsVisible4] = useState(true);
  const [isVisible5, setIsVisible5] = useState(true);
  const [isVisible6, setIsVisible6] = useState(true);
  const [isVisible7, setIsVisible7] = useState(true);

  const [style1, setStyle1] = useState("count1");
  const [style2, setStyle2] = useState("count1");
  const [style3, setStyle3] = useState("count1");
  const [style4, setStyle4] = useState("count1");
  const [style5, setStyle5] = useState("count1");
  const [style6, setStyle6] = useState("count1");
  const [style7, setStyle7] = useState("count1");

  const [activeItem, setActiveItem] = useState(null);

  const handleEnter1 = () => {
    setIsVisible1(!isVisible1);
    setStyle1("count2");
  };

  const handleLeave1 = () => {
    setIsVisible1(!isVisible1);
    setStyle1("count1");
  };

  const handleEnter2 = () => {
    setIsVisible2(!isVisible2);
    setStyle2("count2");
  };

  const handleLeave2 = () => {
    setIsVisible2(!isVisible2);
    setStyle2("count1");
  };

  const handleEnter3 = () => {
    setIsVisible3(!isVisible3);
    setStyle3("count2");
  };

  const handleLeave3 = () => {
    setIsVisible3(!isVisible3);
    setStyle3("count1");
  };

  const handleEnter4 = () => {
    setIsVisible4(!isVisible4);
    setStyle4("count2");
  };

  const handleLeave4 = () => {
    setIsVisible4(!isVisible4);
    setStyle4("count1");
  };

  const handleEnter5 = () => {
    setIsVisible5(!isVisible5);
    setStyle5("count2");
  };

  const handleLeave5 = () => {
    setIsVisible5(!isVisible5);
    setStyle5("count1");
  };

  const handleEnter6 = () => {
    setIsVisible6(!isVisible6);
    setStyle6("count2");
  };

  const handleLeave6 = () => {
    setIsVisible6(!isVisible6);
    setStyle6("count1");
  };

  const handleEnter7 = () => {
    setIsVisible7(!isVisible7);
    setStyle7("count2");
  };

  const handleLeave7 = () => {
    setIsVisible7(!isVisible7);
    setStyle7("count1");
  };

  
  const [ham_bar, setBurgerClass] = useState("burger-bar unclicked");
  const [menu_class, setMenuClass] = useState("menu hidden");
  const [isMenuClicked, setIsMenuClicked] = useState(false);
  
  const handleItemClick = (item) => {
    setActiveItem(item);
    setIsMenuClicked(false)
  };
  const updateMenu = () => {
    if (!isMenuClicked) {
      setBurgerClass("burger-bar clicked");
      setMenuClass("menu visible");
    } else {
      setBurgerClass("burger-bar unclicked");
      setMenuClass("menu hidden");
    }
    setIsMenuClicked(!isMenuClicked);
  };

  return (
    <div style={{ position: "relative" }}>
      <NavDiv id="nav-menu">
        <Flex
          // border = "1px solid pink"
          gap="45px"
          alignItems="center"
          height="90px"
          position="fixed"
          width="100%"
          justifyContent="flex-end"
          pr={5}
          bg="black"
          zIndex={100}
          // display = "none"
        >
          {/* <Logo> */}
          {/* <Text color="white">A</Text>   */}
          {/* <img src={LogoFace} alt="" /> */}
          {/* </Logo> */}

          <BoldPart>
            A<Span1>ns</Span1>h<Span2>Ka</Span2>th<Span1>pal</Span1>
          </BoldPart>

          <Ham className="hamburger" onClick={updateMenu}>
            <HamBar className={ham_bar}></HamBar>
            <HamBar className={ham_bar}></HamBar>
            <HamBar className={ham_bar}></HamBar>
          </Ham>

          <Menubar visible={isMenuClicked}>
            <AnchorLink href="#home">
              <NavItems
                active={activeItem === "Home"}
                onClick={() => handleItemClick("Home")}
              >
                Home
              </NavItems>
            </AnchorLink>
            <AnchorLink href="#about">
              <NavItems
                active={activeItem === "About"}
                onClick={() => handleItemClick("About")}
              >
                About
              </NavItems>
            </AnchorLink>
            <AnchorLink href="#skills">
              <NavItems
                active={activeItem === "Skills"}
                onClick={() => handleItemClick("Skills")}
              >
                Skills
              </NavItems>
            </AnchorLink>
            <AnchorLink href="#projects">
              <NavItems
                active={activeItem === "Projects"}
                onClick={() => handleItemClick("Projects")}
              >
                Projects
              </NavItems>
            </AnchorLink>
            <AnchorLink href="#stats">
              <NavItems
                active={activeItem === "Statistics"}
                onClick={() => handleItemClick("Statistics")}
              >
                Statistics
              </NavItems>
            </AnchorLink>
            <AnchorLink href="#contact">
              <NavItems
                active={activeItem === "Contact"}
                onClick={() => handleItemClick("Contact")}
              >
                Contact
              </NavItems>
            </AnchorLink>
            <a
              href={resume}
              download="Ansh-Kathpal-Resume.pdf"
              id="resume-button-1"
              className='nav-link resume'
            >
              <NavItems
                active={activeItem === "Resume"}
                onClick={() =>
                  window.open(
                    "https://drive.google.com/file/d/1MRMmnBorVqZbjNtpaqmvpc4_MjhzsTFQ/view?usp=sharing"
                  )
                }
                download="Ansh-Kathpal-Resume.pdf"
              // id="resume-button-1"
              // className='nav-link resume'
              >
                Resume
              </NavItems>
            </a>
          </Menubar>

          <AnchorLink href="#home">
            {isVisible1 ? (
              false
            ) : (
              <Box
                // border="1px solid blue"
                bgGradient="linear-gradient(white,black)"
                width="90px"
                top="-8px"
                left="7.5px"
                position="relative"
                height="80px"
                clipPath="polygon(45% 0%,50% 0%, 100% 100%, 0% 100%)"
              ></Box>
            )}
            <Checking1>
              <Button
                // border="1px solid red"
                variant="solid"
                bg="black"
                color="white"
                className={`${style1} nav-link home`}
                // height="max-content"
                onMouseEnter={handleEnter1}
                onMouseLeave={handleLeave1}
                _hover={{ background: "none", color: "rgb(31,229,222)" }}
                display={{ base: "none", lg: "inline" }}
              >
                Home
              </Button>
            </Checking1>
          </AnchorLink>
          <AnchorLink href="#about">
            {isVisible2 ? (
              false
            ) : (
              <Box
                // border="1px solid blue"
                // bg="white"
                bgGradient="linear-gradient(white,black)"
                width="90px"
                top="-8px"
                left="0px"
                position="relative"
                height="80px"
                clipPath="polygon(45% 0%,50% 0%, 100% 100%, 0% 100%)"
              ></Box>
            )}
            <Checking2>
              <Button
                // border="1px solid red"
                width="90px"
                variant="solid"
                bg="black"
                color="white"
                className={`${style2} nav-link about`}
                onMouseEnter={handleEnter2}
                onMouseLeave={handleLeave2}
                _hover={{ background: "none", color: "rgb(31,229,222)" }}
                display={{ base: "none", lg: "inline" }}
              >
                About
              </Button>
            </Checking2>
          </AnchorLink>
          <AnchorLink href="#skills">
            {isVisible3 ? (
              false
            ) : (
              <Box
                // border="1px solid blue"
                // bg="white"
                bgGradient="linear-gradient(white,black)"
                width="90px"
                top="-8px"
                left="0px"
                position="relative"
                height="80px"
                clipPath="polygon(45% 0%,50% 0%, 100% 100%, 0% 100%)"
              ></Box>
            )}
            <Checking3>
              <Button
                // border="1px solid red"
                variant="solid"
                bg="black"
                width="90px"
                color="white"
                className={`${style3} nav-link skills`}
                onMouseEnter={handleEnter3}
                onMouseLeave={handleLeave3}
                _hover={{ background: "none", color: "rgb(31,229,222)" }}
                display={{ base: "none", lg: "inline" }}
              >
                Skills
              </Button>
            </Checking3>
          </AnchorLink>
          <AnchorLink href="#projects">
            {isVisible4 ? (
              false
            ) : (
              <Box
                // border="1px solid blue"
                // bg="white"
                bgGradient="linear-gradient(white,black)"
                width="95px"
                top="-8px"
                left="0px"
                position="relative"
                height="80px"
                clipPath="polygon(45% 0%,50% 0%, 100% 100%, 0% 100%)"
              ></Box>
            )}
            <Checking4>
              <Button
                // border="1px solid red"
                variant="solid"
                bg="black"
                color="white"
                className={`${style4} nav-link projects`}
                onMouseEnter={handleEnter4}
                onMouseLeave={handleLeave4}
                _hover={{ background: "none", color: "rgb(31,229,222)" }}
                display={{ base: "none", lg: "inline" }}
              >
                Projects
              </Button>
            </Checking4>
          </AnchorLink>

          <AnchorLink href="#stats">
            {isVisible6 ? (
              false
            ) : (
              <Box
                // border="1px solid blue"
                // bg="white"
                bgGradient="linear-gradient(white,black)"
                width="100px"
                top="-8px"
                left="0px"
                position="relative"
                height="80px"
                clipPath="polygon(45% 0%,50% 0%, 100% 100%, 0% 100%)"
              ></Box>
            )}
            <Checking6>
              <Button
                // border="1px solid red"
                variant="solid"
                bg="black"
                color="white"
                className={style6}
                onMouseEnter={handleEnter6}
                onMouseLeave={handleLeave6}
                _hover={{ background: "none", color: "rgb(31,229,222)" }}
                display={{ base: "none", lg: "inline" }}
              >
                Statistics
              </Button>
            </Checking6>
          </AnchorLink>

          <AnchorLink href="#contact">
            {isVisible5 ? (
              false
            ) : (
              <Box
                // border="1px solid blue"
                // bg="white"
                bgGradient="linear-gradient(white,black)"
                width="90px"
                top="-8px"
                left="0px"
                position="relative"
                height="80px"
                clipPath="polygon(45% 0%,50% 0%, 100% 100%, 0% 100%)"
              ></Box>
            )}
            <Checking5>
              <Button
                // border="1px solid red"
                variant="solid"
                bg="black"
                color="white"
                className={`${style5} nav-link contact`}
                onMouseEnter={handleEnter5}
                onMouseLeave={handleLeave5}
                _hover={{ background: "none", color: "rgb(31,229,222)" }}
                display={{ base: "none", lg: "inline" }}
              >
                Contact
              </Button>
            </Checking5>
          </AnchorLink>

          <a
            href={resume}
            download="Ansh-Kathpal-Resume.pdf"
            id="resume-button-1"
              className='nav-link resume'
          >
            {isVisible7 ? (
              false
            ) : (
              <Box
                // border="1px solid blue"
                // bg="white"
                bgGradient="linear-gradient(white,black)"
                width="90px"
                top="-8px"
                left="0px"
                position="relative"
                height="80px"
                clipPath="polygon(45% 0%,50% 0%, 100% 100%, 0% 100%)"
              ></Box>
            )}
            <Checking5>
              <Button
                // border="1px solid red"
                variant="solid"
                bg="black"
                color="white"
                className={`${style7} nav-link resume`}
                onMouseEnter={handleEnter7}
                onMouseLeave={handleLeave7}
                _hover={{ background: "none", color: "rgb(31,229,222)" }}
                onClick={() =>
                  window.open(
                    "https://drive.google.com/file/d/1MRMmnBorVqZbjNtpaqmvpc4_MjhzsTFQ/view?usp=sharing"
                  )
                }
                display={{ base: "none", lg: "inline" }}
              >
                Resume
              </Button>
            </Checking5>
          </a>
        </Flex>
      </NavDiv>
    </div>
  );
}

const rotate = keyframes`

from {

  transform : rotate(-360deg)

}

to {

  transform : rotate(360deg)

}

`;

const Logo = styled.div`
  animation: ${rotate};
  animation-duration: 10s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  border-radius: 50%;
  width: 4%;
  border: 2px dashed white;
  padding: 20px;
  position: absolute;
  left: 5%;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const slideIn = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0%);
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(100%);
  }
`;

const textfade = keyframes`
  
  0% {
    opacity : 0;
    transform : 'translateY(-20px)';
  }

  100% {
    opacity : 1;
    transform : 'translateY(0px)'
  }

`;

const NavDiv = styled.div`
  animation-name: ${textfade};
  animation-duration: 2s;
`;

const Checking1 = styled.span`
  .count1 {
    /* border: 1px solid blue; */
  }

  .count2 {
    /* border : 1px solid red; */
    position: relative;
    top: -40px;
    left: 6.7px;
  }
`;
const Checking2 = styled.span`
  .count1 {
    /* border: 1px solid blue; */
  }

  .count2 {
    /* border : 1px solid red; */
    position: relative;
    top: -40px;
    left: 0px;
  }
`;
const Checking3 = styled.span`
  .count1 {
    /* border: 1px solid blue; */
  }

  .count2 {
    /* border : 1px solid red; */
    position: relative;
    top: -40px;
    left: 0px;
  }
`;
const Checking4 = styled.span`
  .count1 {
    /* border: 1px solid blue; */
  }

  .count2 {
    /* border : 1px solid red; */
    position: relative;
    top: -40px;
    left: 0px;
  }
`;
const Checking5 = styled.span`
  .count1 {
    /* border: 1px solid blue; */
  }

  .count2 {
    /* border : 1px solid red; */
    position: relative;
    top: -40px;
    left: 0px;
  }
`;

const Checking6 = styled.span`
  .count1 {
    /* border: 1px solid blue; */
  }

  .count2 {
    /* border : 1px solid red; */
    position: relative;
    top: -40px;
    left: 0px;
  }
`;

const BoldPart = styled.b`
  color: #fee;
  text-shadow: 0 -30px 90px, 0 0 1px, 0 0 1em rgb(31, 229, 222),
    0 0 0.1em rgb(31, 229, 222), 0 0 0.1em rgb(31, 229, 222), 0 10px 3px #000000;
  font-family: "Mogra", cursive;
  position: absolute;
  left: 5%;
  font-size: 40px;
  /* border : 1px solid red; */

  @media screen and (max-width: 480px) {
    width: 60%;
    position: absolute;
    left: 3%;
    font-size: 24px;
  }

  @media screen and (min-width: 1024px) {
    position: absolute;
    left: 5%;
    /* width: 15%; */
    font-size: 40px;
  }
`;

const Ham = styled.div`
  display: none;
  width: 8%;
  height: 26%;
  /* background-color: red; */

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: absolute;
  }
`;

const HamBar = styled.div`
  @media screen and (max-width: 768px) {
    width: 100%;
    /* border : 1px solid blue; */
    height: 13%;
    background-color: white;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    width: 70%;
    /* border : 1px solid blue; */
    height: 13%;
    background-color: white;
  }
`;

const Menubar = styled.div`
  @media screen and (max-width: 767px) {
    width: 100%;
    height: 90vh;
    position: absolute;
    background-color: rgba(31, 229, 222);
    box-shadow: rgba(31, 229, 222, 0.35) 0px -70px 36px -28px inset;
    right: 0%;
    top: 100%;
    z-index: 5;
    opacity: ${(props) => (props.visible ? "1" : "0")};
    transform: ${(props) =>
      props.visible ? "translateX(0%)" : "translateX(100%)"};
    transition: opacity 0.3s ease, transform 0.3s ease;
    display: flex;
    flex-direction: column;
    gap: 30px;
    justify-content: flex-start;
    /* margin-top : 10px; */
    padding-top: 30px;
    align-items: center;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 48% 100%);
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
    height: 90vh;
    position: absolute;
    background-color: rgba(31, 229, 222);
    box-shadow: rgba(31, 229, 222, 0.35) 0px -70px 36px -28px inset;
    right: 0%;
    top: 100%;
    z-index: 5;
    opacity: ${(props) => (props.visible ? "1" : "0")};
    transform: ${(props) =>
      props.visible ? "translateX(0%)" : "translateX(100%)"};
    transition: opacity 0.3s ease, transform 0.3s ease;
    display: flex;
    flex-direction: column;
    gap: 30px;
    justify-content: flex-start;
    /* margin-top : 10px; */
    padding-top: 30px;
    align-items: center;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 48% 100%);
  }
`;

const NavItems = styled.text`
  display: none;
  cursor: pointer;

  color: ${(props) => (props.active ? "white" : "black")};

  @media screen and (max-width: 767px) {
    display: inline;
    font-family: "Mogra", cursive;
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    display: inline;
    font-family: "Mogra", cursive;
    font-size: 30px;
  }
`;

const blink = keyframes`

78% {
    color: inherit;
    text-shadow: inherit;
  }
  79%{
     color: #333;
  }
  80% {
    
    text-shadow: none;
  }
  81% {
    color: inherit;
    text-shadow: inherit;
  }
  82% {
    color: #333;
    text-shadow: none;
  }
  83% {
    color: inherit;
    text-shadow: inherit;
  }
  92% {
    color: #333;
    text-shadow: none;
  }
  92.5% {
    color: inherit;
    text-shadow: inherit;
  }


`;

const Span1 = styled.span`
  animation: ${blink} linear infinite 3s;
`;

const Span2 = styled.span`
  animation: ${blink} linear infinite 3s;
`;

const Hamburger = styled.div`
  color: white;
  border: 1px solid red;
  display: none;

  @media screen and (max-width: 480px) {
    display: inline;
    position: absolute;
    width: 10%;
    right: 10%;
  }

  img:active {
    display: none;
  }
`;
